// extracted by mini-css-extract-plugin
export var infoRow = "_qz-2";
export var labelContainer = "_qz-0";
export var rightInfo = "_qz-1";